// Usage:
//
// import _ from 'lodash';
// import BaseStore from '.../common/store/BaseStore';
// import Dispatcher from '.../common/dispatcher/Dispatcher';
//
// class YourStore extends BaseStore {
//   constructor() {
//     super();
//     this.bindActions(
//        YourActions.ACTION, this.actionHandler,
//        ..
//     )
//   }
// });


import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher/Dispatcher';

class BaseStore extends EventEmitter {
  constructor() {
    super();
    this.dispatcherIndex =
      Dispatcher.register(this.dispatcherCallback.bind(this));
  }
  bindActions() {
    this._actionMap = {};
    for (let i = 0; i < arguments.length; i += 2) {
      let actionType = arguments[i],
          handler = arguments[i + 1];

      if (!actionType) {
        console.error('Undefined action type: You have probably misspelled it!');
        continue;
      }

      if (!handler) {
        console.error('Undefined handler: You have probably misspelled it!');
        continue;
      }

      this._actionMap[actionType] = handler.bind(this);
    }
  }
  addChangeListener(callback) {
    this.addListener('change', callback);
  }
  removeChangeListener(callback) {
    this.removeListener('change', callback);
  }
  emitChange() {
    this.emit('change');
  }
  dispatcherCallback(payload) {
    if (!this._actionMap) {
      throw 'Call bindActions first';
    }

    var action = payload.action,
        handler = this._actionMap[action.actionType];

    if (handler) {
      handler(action);
      this.emitChange();
    }

    return true;
  }
  once(func) {
    const actionToken = Symbol();
    this._actionMap[actionToken] = action => {
      delete this._actionMap[actionToken];
      if (!action.hide)
        return func(action);
    };
    return actionToken;
  }
}

export default BaseStore;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/stores/BaseStore.js
 **/